<template>
  <van-steps
    :active="step - 2"
    active-color="#289753"
    class="all-steps"
  >
    <!-- <van-step><span :class="{ green: step > 0 }">{{ $t('ppwc.p3') }}</span></van-step> -->
    <van-step>
      <span :class="{ green: step > 1 }">
        {{ $t('ppwc.p4') }}
      </span>
    </van-step>
    <van-step>
      <span :class="{ green: step > 2 }">
        {{ $t('ppwc.p5') }}
      </span>
    </van-step>
    <van-step>
      <span :class="{ green: step > 3 }">
        {{ $t('ppwc.p6') }}
      </span>
    </van-step>
  </van-steps>
</template>

<script>
export default {
  props: ['step'],
  data() {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.all-steps {
  margin-bottom: 10px;
  padding-top: 10px;
  /deep/.van-step--finish .van-step__circle, /deep/.van-step--finish .van-step__line {
    background-color: #289753;
  }
}
.green {
  color: #289753;
}
</style>
